import {useParams} from "react-router-dom";
import {Container} from "react-bootstrap";

import {RenderMarkdownGitHub} from "./utils/utilsForMarkdown";
import {useBrowserTitle} from "../hooks/useBrowserTitle";

// export function RoutesGit() {
//     useBrowserTitle("Info")
//     const {base, "*": path} = useParams()
//
//     let resourcePath
//     if (!base) {
//         resourcePath = path || "README.md"; // root README.md
//     } else {
//         resourcePath = `${base}/${path || "README.md"}`; // folder README.md
//     }
//
//     // Build the GitHub raw URL
//     const githubUrl = `https://raw.githubusercontent.com/altrabits/AB_Documents/main/${resourcePath}`
//
//     return <Container fluid="lg">
//         <RenderMarkdownGitHub routerPath={`/git/${base}`} github={githubUrl}/>
//     </Container>
// }

export function RoutesGit(){
    const {"*": path} = useParams()

    const githubUrl = `https://raw.githubusercontent.com/altrabits/AB_Documents/main/${path}`

    return <Container fluid="lg">
        <RenderMarkdownGitHub github={githubUrl}/>
    </Container>
}